import {create} from 'zustand';
import {OverbookingModalStore} from './types';

const useOverbookingModalStore = create<OverbookingModalStore>(set => ({
	overbookingModalOpen: false,
	setOverbookingModalOpen: value => set({overbookingModalOpen: value}),
}));

export {useOverbookingModalStore};
